import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import Services from "./sections/Services";
import Pricing from "./sections/Pricing";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <Services />
      <Pricing />
      <Footer />
    </div>;
}